import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EntityService } from '../core/entity.service';
import { Profile } from '../shared/configurations/profile.constant';
import { RestApiBase } from '../shared/configurations/rest-api-base.config';
import {
    ListDataParameters,
    PageListData,
} from '../shared/interfaces/list-data-params';
import { ResearchResource } from '../shared/interfaces/research-resources.interface';
import { UrlUtils } from '../shared/utils/url.utils';

@Injectable({
    providedIn: 'root',
})
export class ResourcesService extends EntityService {
    private _http = inject(HttpClient);

    bulkSize = Profile.BULK_GRID_SIZE;
    dataParams: ListDataParameters;

    constructor() {
        super();
        this.institutionCode = UrlUtils.getParam('institution');
        this.api = RestApiBase.ResearchResourcesAPi;
    }

    getListDataParameters(_offset?: number, lang?: string) {
        const defaultListDataParams: ListDataParameters = {
            pagination: { rows: this.bulkSize, offset: _offset },
            facets: {},
            filters: {},
            language: lang,
            search: { searchText: '', searchType: 'RESEARCH_RESOURCE' },
            sorts: [{ sortBy: 'name', sortDir: 'asc' }],
        };
        return defaultListDataParams;
    }

    getListResources(offset: number, lang: string) {
        const _params = new HttpParams().set(
            'institution',
            this.institutionCode,
        );

        return this._http.post<PageListData<ResearchResource>>(
            `${this.api.base}/profile/query`,
            this.getListDataParameters(offset, lang),
            { params: _params },
        );
    }
}
